import { Flex } from '@/components/base';

import ChartHeader from '../../chart-header';

type Props = {
  chartInfo: ChartContextProps;
};

export function ChartDetailHeader({ chartInfo }: Props) {
  return (
    <Flex className="flex-shrink-0 w-full pl-6 pr-8">
      <ChartHeader chartInfo={chartInfo} />
    </Flex>
  );
}
